import { useEffect, useState } from "react";
import { getAdminDashboardStats } from "../../services/firestoreService";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";

function AdminDashboard() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [stats, setStats] = useState({ totalTips: 0, totalPaid: 0, totalPending: 0 });
    const [loading, setLoading] = useState(true);
    const [loggingOut, setLoggingOut] = useState(false);

    useEffect(() => {
        const fetchStats = async () => {
            const data = await getAdminDashboardStats();
            setStats(data);
            setLoading(false);
        };

        fetchStats();
    }, []);

    const handleLogout = async () => {
        if (loggingOut) return;
        setLoggingOut(true);
        await logout();
        navigate("/login", { replace: true });
    };

    return (
        <div className="relative flex flex-col items-center justify-center h-screen bg-gray-100 p-6">
            <button
                type="button"
                onClick={handleLogout}
                disabled={loggingOut}
                className="absolute right-6 top-6 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-wait disabled:opacity-60"
            >
                {loggingOut ? "Logging out…" : "Log out"}
            </button>
            {loading ? (
                <p className="text-lg text-gray-500">Loading dashboard...</p>
            ) : (
                <>
                    <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">
                        <div className="bg-white p-6 shadow-md rounded-lg text-center">
                            <h2 className="text-lg font-semibold mb-2">Total Tips Collected</h2>
                            <p className="text-2xl font-bold">€{stats.totalTips.toFixed(2)}</p>
                        </div>
                        <div className="bg-yellow-100 p-6 shadow-md rounded-lg text-center">
                            <h2 className="text-lg font-semibold mb-2">Pending Payouts</h2>
                            <p className="text-2xl font-bold text-yellow-600">€{stats.totalPending.toFixed(2)}</p>
                        </div>
                        <div className="bg-green-100 p-6 shadow-md rounded-lg text-center">
                            <h2 className="text-lg font-semibold mb-2">Total Paid Out</h2>
                            <p className="text-2xl font-bold text-green-600">€{stats.totalPaid.toFixed(2)}</p>
                        </div>
                    </div>

                    <div className="mt-6">
                        <Link to="/admin/payouts" className="bg-blue-500 text-white px-6 py-2 rounded-md text-lg">
                            Manage Payouts
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminDashboard;
